export class WeekModel {
    dateDebut?: string;
    dateFin?: string;


    constructor(dateDebut: string, dateFin: string) {
        this.dateDebut = dateDebut;
        this.dateFin = dateFin;
    }

    toStringURL(): string {
        return encodeURIComponent(JSON.stringify(this));
    }
}
